import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=9faf944c&scoped=true"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=9faf944c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9faf944c",
  null
  
)

export default component.exports